import {FormControl, FormGroup} from '@angular/forms';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {getEditTypes} from '../../../delegatorUtils';
import {EditPermissions} from '../../../../../../../shared/models';
import {required, variableCheck, variableCheckSession} from '../../../../../../../shared/utils';

export interface SetVariableFormType {
    actionParams: any;
    actionVariables: any;
}

export class SetVariableNode {
    action: any = {};

    constructor(nodeType: string) {
        this.action = {
            'actionType': nodeType,
        };
    }

    static toForm(stepData: { [index: string]: any }): SetVariableFormType {
        return {
            actionParams: this.actionParamsForm(stepData),
            actionVariables: this.actionVariablesForm(stepData)
        };
    }

    static actionParamsForm(stepData: { [index: string]: any }): {} {
        const action = stepData.action;
        return {
            name: action?.name ? action.name : '',
            description: action?.description ? action.description : '',
            success: action?.result && action?.result.success ? action?.result.success : newStepValue,
            report: action?.report ? action?.report : '',
        };
    }

    static actionVariablesForm(stepData: { [index: string]: any }): {} {
        const action = stepData.action;
        const paramsList: Object[] = [];
        const variables: Map<string, string> = action && action.actionParams && action.actionParams.variables
            ? action.actionParams.variables
            : undefined;
            for (const key in variables) {
                const mapVar: { [index: string]: string } = variables[key];
                const itemFormData = {
                    variableName: key,
                    variableValue: mapVar
                };
                paramsList.push(itemFormData);
            }
        return paramsList;

    }

    static getActionTemplate(editPermissions: EditPermissions): FormGroup {
        const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);

        return new FormGroup({
            name: new FormControl({
                value: '',
                disabled: !editFlows
            }),
            description: new FormControl({
                value: '',
                disabled: !editFlows
            }, required('Description')),
            success: new FormControl(newStepValue),
            report: new FormControl({
                value: '',
                disabled: !editFlows
            })
        });
    }

    static getVariablesTemplate(editPermissions: EditPermissions): FormGroup {
        const {editFlows} = getEditTypes(editPermissions);

        return new FormGroup({
            variableName: new FormControl({
                value: '',
                disabled: !editFlows
            }, [
                variableCheck(),
                variableCheckSession(),
                required('Variable Name')]),
            variableValue: new FormControl({
                value: '',
                disabled: !editFlows
            }),
        });
    }

    get nodeData(): {} {
        return {
            action: this.action,
            'type': 'action',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

    addActionParams(params) {
        const { description, report } = params;
        const name = 'Set Variables';
        this.action = {
            ...this.action,
            name,
            description,
            report
        };
    }

    addVariables(variables) {
        this.action = {
            ...this.action,
            actionParams: {
                variables: this.getVarables(variables)
            }
        };
    }

    getVarables(variables) {
        const variableMap: { [index: string]: string } = {};
        for (const variable of variables) {
            variableMap[variable.variableName] = variable.variableValue;
        }
        return variableMap;
    }

    addResult(success: string) {
        this.action = {
            ...this.action,
            result: {
                success: success
            }
        };
    }
}
